export const updateSSOTokenReducer = {
  updateSSOToken: (state, action) => {
    state.ssoToken = action.payload;
  },
};
